// Zcash shield watermark, viewBox 0 0 600 700.
//
// Two subpaths in one `d`, rendered with fill-rule "evenodd" so the second one
// (a bold "Z") is punched out of the first (a heraldic shield) — the "shielded
// ZEC" device. Recoloured to the partner accent in ShieldGlyph.tsx.
export const SHIELD_GLYPH_PATH =
  "M300 40 L558 122 C558 330 512 508 300 662 C88 508 42 330 42 122 Z " +
  "M195 215 L405 215 L273 450 L405 450 L405 505 L195 505 L327 270 L195 270 Z";
